// Types
import { GetNotReviewedAnyAiClipCandidates_getNotReviewedAnyAiClipCandidates } from 'api/interview/types/GetNotReviewedAnyAiClipCandidates';
import { GetMediaPostsInput } from 'api/graphql-global-types';
// Components
import AiClipReviewPanel from '../AiClipReviewPanel/AiClipReviewPanel';
// Ui
import Modal from 'ui3/Modal/Modal';
// Styles
import styles from './ReviewAiClipCandidateModal.module.scss';

type ReviewAiClipCandidateModalProps = {
  storeId: string;
  isOpen: boolean;
  onClose: () => void;
  candidate: GetNotReviewedAnyAiClipCandidates_getNotReviewedAnyAiClipCandidates;
  /** 1-based position used for the "AI Clip #N" label. */
  index: number;
  /** Active GET_MEDIA_POSTS variables of the mounting surface, for refetch. */
  mediaPostsQueryInput?: GetMediaPostsInput;
  /** Optional class for overlay and container (e.g. dashboard smart-banner padding). */
  modalAreaClassName?: string;
  /** Optional class applied to the modal div (e.g. for dashboard smart-banner margin). */
  modalClassName?: string;
};

const ReviewAiClipCandidateModal = ({
  storeId,
  isOpen,
  onClose,
  candidate,
  index,
  mediaPostsQueryInput,
  modalAreaClassName,
  modalClassName,
}: ReviewAiClipCandidateModalProps): JSX.Element => (
  <Modal
    open={isOpen}
    onClose={onClose}
    title="Review AI clip"
    subTitle="Approve to publish it on your media feed, or reject to remove it."
    size="large"
    className={modalClassName}
    modalAreaClassName={modalAreaClassName}
    scrollable
  >
    <AiClipReviewPanel
      className={styles.panel}
      storeId={storeId}
      candidate={candidate}
      index={index}
      mediaPostsQueryInput={mediaPostsQueryInput}
      onReviewed={onClose}
    />
  </Modal>
);

export default ReviewAiClipCandidateModal;
